import { render, staticRenderFns } from "./StatisticsMain.vue?vue&type=template&id=975088e8&"
import script from "./StatisticsMain.vue?vue&type=script&lang=js&"
export * from "./StatisticsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports